import React, { useState } from "react"
import {
  SearchableSelectOption,
} from "@humanpredictiveintelligence/myqvt-library"
import { t } from "ttag"

import {
  ThemeQuestion,
  ThemeQuestionWithTheme,
  ThemeWithQuestions,
  ThemeWithQuestionsNested,
} from "features/Surveys/CustomSurveys/models"
import { getSelectOptionFromTheme } from "features/Surveys/utils"
import * as Styles from "./ThemeQuestionsSection.styles"
import { ThemeQuestionItem } from "../ThemeQuestionItem"

export const ThemeQuestionsSection: React.FC<ThemeQuestionsSectionProps> = (props) => {
  const [ openedChoicesOfQuestionId, setOpenedChoicesOfQuestionId ] = useState<number>()

  const themeSelectOptions = React.useMemo(
    () => getSelectOptionsFromThemes(props.themes || []),
    [ props.themes ])

  const selectedTheme = props.selectedTheme

  return (
    <Styles.Container>
      <Styles.SectionTitle>
        {t`Questions Library`}
      </Styles.SectionTitle>
      <Styles.ThemeSelect
        label={t`List of themes`}
        options={themeSelectOptions}
        selectPlaceholder={t`Select a theme`}
        isLoading={props.areThemesLoading}
        onChange={(selectedOptions) => selectedOptions[0] && props.onThemeChange(selectedOptions[0].value)}
      />
      {selectedTheme
        ? (
          <Styles.QuestionList
            icon={selectedTheme.icon}
            color={selectedTheme.color}
            coloredTitle={t`List of questions`}
          >
            {selectedTheme.questions.map((question, questionIndex) => (
              <ThemeQuestionItem
                key={question.id}
                theme={selectedTheme}
                questionIndex={questionIndex}
                question={question}
                onQuestionToggled={() => props.onQuestionToggled(question)}
                areChoicesOpen={openedChoicesOfQuestionId === question.id}
                isReadOnly={props.isReadOnly}
                isQuestionSelected={isQuestionSelected(question, props.selectedQuestions)}
                onChoicesOpen={() => setOpenedChoicesOfQuestionId(question.id)}
                onChoicesClose={() => setOpenedChoicesOfQuestionId(undefined)}
              />
            ))}
          </Styles.QuestionList>
        )
        : <Styles.EmptyQuestionList>{t`No theme selected`}</Styles.EmptyQuestionList>
      }
    </Styles.Container>
  )

  function isQuestionSelected(question: ThemeQuestion, selectedQuestions: ThemeQuestion[]): boolean {
    return selectedQuestions.some(selectedQuestion => selectedQuestion.id === question.id)
  }

  function getSelectOptionsFromThemes(themes: ThemeWithQuestions[]): SearchableSelectOption[] {
    return themes.reduce((selectOptions, theme) => {
      if (theme.questions.length > 0) {
        selectOptions.push(getSelectOptionFromTheme(theme))
      }

      return selectOptions
    }, new Array<SearchableSelectOption>())
  }
}

interface ThemeQuestionsSectionProps {
  themes: ThemeWithQuestionsNested[],
  areThemesLoading: boolean,
  selectedQuestions: ThemeQuestionWithTheme[],
  selectedTheme?: ThemeWithQuestionsNested,
  onQuestionToggled: (question: ThemeQuestionWithTheme) => void,
  onThemeChange: (themeId: string) => void,
  isReadOnly: boolean,
}
